import { Button } from "@/components/ui/button";
import { LoadingSpinner } from "@/components/LoadingSpinner";
import {
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface ManageSubscriptionContentProps {
  isLoading: boolean;
  onManageSubscription: () => Promise<void>;
}

export function ManageSubscriptionContent({
  isLoading,
  onManageSubscription,
}: ManageSubscriptionContentProps) {
  return (
    <DialogContent className="sm:max-w-[425px]">
      <DialogHeader>
        <DialogTitle>Manage Subscription</DialogTitle>
        <DialogDescription>
          You will be redirected to Stripe's customer portal to manage your subscription.
        </DialogDescription>
      </DialogHeader>
      <div className="flex justify-end">
        <Button onClick={onManageSubscription} disabled={isLoading}>
          {isLoading ? <LoadingSpinner /> : 'Continue to Portal'}
        </Button>
      </div>
    </DialogContent>
  );
}